// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3L23 3V21H1L1 3ZM21 11H19.0005L19 16H17V11H15V16H13V11H11V16H9V11H7V16H5V11H3L3 19H21V11Z"}}]};

const PianoFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'piano-filled',
    ref,
    icon: element,
  },
));

PianoFilledIcon.displayName = 'PianoFilledIcon';

export default PianoFilledIcon;
